module.exports = __webpack_public_path__ + "static/media/loxone-history-1-mobile.4d27e1e5.png";